(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;
  const animBusy = U.animBusy;
  const artStyle = U.artStyle;
  const backSvg = U.backSvg;
  const beginDrag = U.beginDrag;
  const cardActions = U.cardActions;
  const cardTitle = U.cardTitle;
  const clickCard = U.clickCard;
  const closeInspector = U.closeInspector;
  const dispatch = U.dispatch;
  const el = U.el;
  const esc = U.esc;
  const groupMoveDests = U.groupMoveDests;
  const live = U.live;
  const markStates = U.markStates;
  const pcls = U.pcls;
  const poolToken = U.poolToken;
  const renderHandCard = U.renderHandCard;
  const setShowLog = U.setShowLog;
  const togglePick = U.togglePick;
  const viewPlayer = U.viewPlayer;

  function renderLegendSlot(state, p) {
    const pl = state.players[p];
    const legend = state.objs[pl.legendIid];
    const slot = el("div", "bigslot");
    const lc = el("div", "bigcard" + (legend.ready ? " gold" : ""));
    lc.setAttribute("data-iid", pl.legendIid);
    artStyle(lc, state, pl.legendIid, "full");
    lc.title = cardTitle(state, pl.legendIid);
    lc.onclick = function (ev) { clickCard(pl.legendIid, ev); };
    if (APP.selection === pl.legendIid) lc.classList.add("selected");
    U.markPay(lc, state, pl.legendIid);
    slot.appendChild(lc);
    slot.appendChild(el("span", "slotplate " + (legend.ready ? "ready" : "used"), "LEGEND · " + (legend.ready ? "READY" : "USED")));
    return slot;
  }

  function renderChampSlot(state, p, mine) {
    const pl = state.players[p];
    const slot = el("div", "bigslot");
    if (pl.champion.length) {
      const iid = pl.champion[0];
      const cc = el("div", "bigcard card");
      cc.setAttribute("data-iid", iid);
      artStyle(cc, state, iid, "full");
      cc.title = cardTitle(state, iid);
      markStates(cc, state, iid);
      if (mine && U.LEGAL && !U.LEGAL.play[iid]) cc.classList.add("illegal");
      cc.onclick = function (ev) { clickCard(iid, ev); };
      if (mine) cc.onpointerdown = function (ev) { beginDrag(iid, "hand", ev); };
      slot.appendChild(cc);
      slot.appendChild(el("span", "slotplate" + (mine ? " play" : ""), "CHAMPION" + (pl.champion.length > 1 ? " ×" + pl.champion.length : "") + (mine ? " · PLAYABLE" : "")));
      return slot;
    }
    let deployed = null;
    for (const iid of Core.boardObjs(state, function (o, i2) {
      const cd = Core.card(state, i2);
      return o.controller === p && cd && (cd.supertypes || []).indexOf("champion") >= 0;
    })) { deployed = iid; break; }
    const empty = el("div", "bigcard dashed");
    empty.appendChild(el("span", "zlabel", deployed ? esc(Core.locName(state, state.objs[deployed].loc)) : "No champion"));
    slot.appendChild(empty);
    slot.appendChild(el("span", "slotplate", deployed ? "CHAMPION · DEPLOYED" : "CHAMPION"));
    return slot;
  }

  function renderDeckSlot(state, p) {
    const pl = state.players[p];
    const slot = el("div", "bigslot");
    slot.setAttribute("data-anchor", "deck-" + p);
    const stack = el("div", "pilestack");
    if (pl.mainDeck.length) {
      const layers = Math.min(3, pl.mainDeck.length);
      for (let i = layers - 1; i >= 0; i--) {
        const b = el("div", "cardback pilecard", i === 0 ? backSvg(24) : "");
        b.style.transform = "translate(" + (i * -2) + "px," + (i * -2) + "px)";
        stack.appendChild(b);
      }
    } else {
      stack.appendChild(el("div", "pilecard emptypile", "<span class='zlabel'>EMPTY</span>"));
    }
    slot.appendChild(stack);
    const left = pl.mainDeck.length;
    if (left <= 2) slot.classList.add("deckred");
    else if (left <= 4) slot.classList.add("deckamber");
    slot.appendChild(el("span", "slotplate", "DECK · " + left));
    return slot;
  }

  function renderPileSlot(state, p, key, label, anchor) {
    const pl = state.players[p];
    const ids = pl[key];
    const holdKey = "@pile-" + anchor;
    const A = RB.Anim;
    const held = A && A.hidden[holdKey] && A.prevPiles[anchor] ? A.prevPiles[anchor] : null;
    const shown = held || ids;
    const slot = el("div", "bigslot");
    slot.setAttribute("data-anchor", anchor);
    const stack = el("div", "pilestack" + (ids.length ? " clicky" : ""));
    if (shown.length || ids.length) {
      for (let i = Math.min(2, shown.length - 1); i > 0; i--) {
        const u = el("div", "pilecard undercard");
        u.style.transform = "translate(" + (-i * 2) + "px," + (-i * 2) + "px)";
        stack.appendChild(u);
      }
      if (shown.length) {
        const top = shown[shown.length - 1];
        const face = el("div", "pilecard topcard" + (held ? " held" : ""));
        artStyle(face, state, top, "full");
        face.title = cardTitle(state, top);
        stack.appendChild(face);
      } else {
        stack.appendChild(el("div", "pilecard emptypile held", "<span class='zlabel'>EMPTY</span>"));
      }
      if (held && ids.length && ids[ids.length - 1] !== shown[shown.length - 1]) {
        const newTop = ids[ids.length - 1];
        const arriving = el("div", "pilecard topcard pilearrival prearrive");
        arriving.setAttribute("data-fxkey", holdKey);
        arriving.setAttribute("data-plate", label.toUpperCase() + " · " + ids.length);
        artStyle(arriving, state, newTop, "full");
        arriving.title = cardTitle(state, newTop);
        stack.appendChild(arriving);
      }
      const title = label + " — " + pl.name;
      stack.onclick = function (ev) {
        ev.stopPropagation();
        if (key === "trash" && U.pileActivations(state, ids).length) {
          if (APP.menu && APP.menu.pile === anchor) { closeInspector(); return; }
          APP.selection = null;
          APP.menu = { pile: anchor, title: title, ids: ids, stage: "choose" };
          U.render();
          return;
        }
        U.showPile(title, ids, key === "trash");
      };
    } else {
      stack.appendChild(el("div", "pilecard emptypile", "<span class='zlabel'>EMPTY</span>"));
    }
    slot.appendChild(stack);
    slot.appendChild(el("span", "slotplate", label.toUpperCase() + " · " + shown.length));
    return slot;
  }

  function renderHandSlot(state, p, mine) {
    const pl = state.players[p];
    const wrap = el("div", "handfan");
    wrap.setAttribute("data-anchor", "hand-" + p);
    const fan = el("div", "fan");
    const held = RB.Anim && RB.Anim.heldItem ? RB.Anim.heldItem(state) : null;
    const shown = pl.hand.slice();
    if (held && held.controller === p) {
      const at = held.handIndex >= 0 ? Math.min(held.handIndex, shown.length) : shown.length;
      shown.splice(at, 0, held.iid);
    }
    if (mine) {
      for (const iid of shown) fan.appendChild(renderHandCard(state, iid));
      if (!shown.length) fan.appendChild(el("span", "zlabel", "Hand is empty"));
    } else {
      const n = Math.min(shown.length, 12);
      for (let i = 0; i < n; i++) {
        const back = el("div", "cardback hback", backSvg(18));
        back.setAttribute("data-fxkey", "@hb-" + p + "-" + i);
        if (RB.Anim && RB.Anim.hidden["@hb-" + p + "-" + i]) back.classList.add("prearrive");
        fan.appendChild(back);
      }
      if (!n) fan.appendChild(el("span", "zlabel", "Hand is empty"));
      wrap.title = APP.net ? pl.name + "'s hand is hidden from you"
        : APP.ai[p] ? "The AI's hand stays hidden" : "View from " + pl.name + "'s side";
      if (!APP.net && !APP.ai[p]) {
        wrap.style.cursor = "pointer";
        wrap.onclick = function (ev) { ev.stopPropagation(); APP.viewAs = p; U.render(); };
      }
    }
    wrap.appendChild(fan);
    wrap.appendChild(el("span", "handplate slotplate", "HAND · " + shown.length));
    return wrap;
  }

  function renderStation(state, p, placement) {
    const mine = p === viewPlayer(state);
    if (mine && typeof document !== "undefined" && document.body && document.body.classList) {
      document.body.classList.toggle("burnwarn", state.players[p].mainDeck.length <= 2 && !state.over);
    }
    const station = el("div", "station " + placement + " " + pcls(p) + (mine ? " mine" : " theirs"));
    station.setAttribute("data-anchor", "station-" + p);

    const left = el("div", "stgroup");
    left.appendChild(renderLegendSlot(state, p));
    left.appendChild(renderChampSlot(state, p, mine));
    station.appendChild(left);

    station.appendChild(renderHandSlot(state, p, mine));

    const right = el("div", "stgroup");
    right.appendChild(renderPileSlot(state, p, "banish", "Banish", "banish-" + p));
    right.appendChild(renderPileSlot(state, p, "trash", "Trash", "trash-" + p));
    right.appendChild(renderDeckSlot(state, p));
    station.appendChild(right);

    return station;
  }

  function cardPanel(c, onClose) {
    const div = el("div");
    div.id = "selpanel";
    if (!c) return div;
    if (onClose) {
      const x = el("button", "btn closex", "<svg width='11' height='11' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='2.2' stroke-linecap='round'><path d='M4 4l8 8M12 4l-8 8'></path></svg>");
      x.title = "Close (Esc)";
      x.onclick = onClose;
      div.appendChild(x);
    }
    div.appendChild(el("div", "selname", esc(c.name)));
    const img = document.createElement("img");
    RB.artSrc(img, c, "380px");
    RB.artFallback(img, c);
    div.appendChild(img);
    div.appendChild(el("div", "seltext", U.fmtText(c.text || "(no text)")));
    const bits = [];
    if (c.energy !== undefined && c.energy !== null) {
      bits.push(c.energy + " energy" + (c.power ? " + " + c.power + " power" : ""));
    }
    if ((c.domains || []).length) bits.push((c.domains || []).join(" / "));
    div.appendChild(el("div", "selmeta", esc(bits.join(" · "))));
    return div;
  }

  function renderSelPanel(state) {
    const iid = APP.selection;
    if ((!iid || !state.objs[iid]) && APP.peek) {
      return cardPanel(APP.peek, function () { APP.peek = null; U.render(); });
    }
    if (!iid || !state.objs[iid]) return null;
    const o = state.objs[iid];
    const c = Core.card(state, iid);
    const div = cardPanel(c, function () { APP.selection = null; U.render(); });

    const meta = div.querySelector(".selmeta");
    const bits = meta && meta.textContent ? [meta.textContent] : [];
    if (o.zone === "board" && Core.isType(state, iid, "unit")) {
      bits.push(Core.effMight(state, iid) + " Might");
      const dmg = Core.totalDamage(o);
      if (dmg) bits.push(dmg + " damage marked");
    }
    if (meta) {
      if (bits.length) meta.textContent = bits.join(" · ");
      else meta.remove();
    }
    const status = U.zoomStatus(state, iid);
    if (status) div.appendChild(el("div", "selstatus", esc(status)));
    return div;
  }

  function renderGroupTray(state) {
    const p = U.groupActor(state);
    if (p === null || !U.groupOpen(state)) return null;
    const g = U.moveGroup(state);
    const dests = g.length ? groupMoveDests(state, p, g) : [];
    const culprits = U.groupCulprits(state, p, g);
    const div = el("div", null);
    div.id = "grouptray";
    div.onclick = function (ev) { ev.stopPropagation(); };

    const head = el("div", "gthead");
    head.appendChild(el("h3", null, "Move as a group"));
    if (!g.length) {
      head.appendChild(el("span", "note", "Click your ready units to gather them."));
    } else if (culprits.length) {
      head.appendChild(el("span", "error", esc(culprits.map(function (iid) { return Core.name(state, iid); }).join(", ")) +
        (culprits.length > 1 ? " share" : " shares") + " no destination with the rest."));
    } else if (!dests.length) {
      head.appendChild(el("span", "error", "These units have no destination in common."));
    } else {
      head.appendChild(el("span", "note", "Click another ready unit to add it, or pick a destination."));
    }
    div.appendChild(head);

    const sprites = el("div", "gtsprites");
    for (let i = 0; i < g.length; i++) {
      sprites.appendChild(U.groupSprite(state, g[i], i + 1, culprits.indexOf(g[i]) >= 0));
    }
    if (!g.length) sprites.appendChild(el("span", "zlabel", "No units yet"));
    div.appendChild(sprites);

    const actions = el("div", "actions");
    for (const dest of dests) {
      (function (dest) {
        const b = el("button", "btn primary", dest.t === "base" ? "All to base" : "All to " + esc(Core.name(state, dest.iid)));
        b.onclick = function (ev) {
          ev.stopPropagation();
          dispatch({ type: "STANDARD_MOVE", player: p, units: g.slice(), dest: dest });
        };
        actions.appendChild(b);
      })(dest);
    }
    const cancel = el("button", "btn", "Cancel");
    cancel.onclick = function (ev) { ev.stopPropagation(); U.clearGroup(); };
    actions.appendChild(cancel);
    div.appendChild(actions);
    return div;
  }

  function cancelButton(pd) {
    const b = el("button", "btn danger", "Cancel");
    b.title = "Take the card back. Targeting is part of the cost, so nothing has been paid yet.";
    b.onclick = function (ev) {
      if (ev) ev.stopPropagation();
      dispatch({ type: "CANCEL", player: pd.player });
    };
    return b;
  }

  function confirmButtons(pd) {
    const out = [];
    const enough = APP.picked.length >= Math.max(1, pd.min || 0);
    const ok = el("button", "btn primary" + (enough ? "" : " off"), "Confirm choice");
    if (enough) {
      ok.onclick = function (ev) {
        if (ev) ev.stopPropagation();
        dispatch({ type: "CHOOSE", player: pd.player, picks: APP.picked.slice() });
      };
    } else {
      ok.disabled = true;
    }
    out.push(ok);
    if ((pd.min || 0) === 0) {
      const none = el("button", "btn", "Choose none");
      none.onclick = function (ev) {
        if (ev) ev.stopPropagation();
        dispatch({ type: "CHOOSE", player: pd.player, picks: [] });
      };
      out.push(none);
    }
    return out;
  }

  Object.assign(U, { renderLegendSlot: renderLegendSlot, renderChampSlot: renderChampSlot, renderDeckSlot: renderDeckSlot, renderPileSlot: renderPileSlot, renderStation: renderStation, renderSelPanel: renderSelPanel, cardPanel: cardPanel, renderGroupTray: renderGroupTray, confirmButtons: confirmButtons, cancelButton: cancelButton });
})();
